if (document.querySelector('.input-box-dekaz.name')) {
    // console.log('nombre')
    const inputGroups = document.querySelectorAll('.input-box-dekaz.name')
    const lang = document.documentElement.lang
    let textError = ''
    if (lang === 'es' || lang === 'es-CL') {
        textError = 'Este campo no puede estar vacio'
      } else {
        textError = 'This field can not be blank'
      }
    inputGroups.forEach(inputGroup => {
        //   inputGroup  
        const inp = inputGroup.querySelector('input')
        const error = inputGroup.nextElementSibling
        // console.log(inp)
        if (inp) {
            inp.addEventListener('keyup', (e) => {
                // console.log(inp.value)
                if(inp.value === '') {
                    error.classList.add('active')
                    inputGroup.classList.add('invalid')
                    error.innerHTML = textError
                } else {
                    error.classList.remove('active')
                    inputGroup.classList.remove('invalid')
                }
            })
        }
    })
}

export function validateName(form){
    const inputGroups = form.querySelectorAll('.input-box-dekaz.name')
    let errorEx = false
    if(inputGroups){
        let textError = ''
        const lang = document.documentElement.lang
        if (lang === 'es' || lang === 'es-CL') {
            textError = 'Este campo no puede estar vacio'
        } else {
            textError = 'This field can not be blank'
        }
        inputGroups.forEach(inputGroup => {
            //   inputGroup  
            const inp = inputGroup.querySelector('input')
            const error = inputGroup.nextElementSibling
            if(inp.value === '') {
                error.classList.add('active')
                inputGroup.classList.add('invalid')
                error.innerHTML = textError
                errorEx = true
            }
        })
    }
    return errorEx
}

// import {validateName} from '@/js/components/validation/class/val_name'